// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1eSkn","messages":"Chat_messages__3HaWX","dateDivider":"Chat_dateDivider__EUEiI"};